import React, { Component } from 'react';
import { Container } from '@mui/material';
import globalClasses from '../Layout.module.css';
import _ from 'classnames';
import i18n from 'i18n/I18nInstance';
import { FormattedMessage } from 'react-intl';

export default class NoContentAvailable extends Component {
    render() {
        const i18n_blankPage = i18n.translator.formatMessage({
            id: 'common.BlankPage',
            defaultMessage: 'Blank page',
        });
        return (
            <div className={globalClasses.blankPageMessage}>
                <div className={globalClasses.blankPageImg}>
                    <img
                        data-qaid="blankPageImageImg"
                        className="blankPageImage"
                        alt={i18n_blankPage}
                        src="./img/blank-page.svg"
                    ></img>
                </div>
                <Container style={{ paddingRight: 16, paddingLeft: 16 }}>
                    <div
                        data-qaid="blankPageText"
                        className={_(
                            globalClasses.typography_body1,
                            globalClasses.blankPageText,
                            globalClasses.centeredText,
                        )}
                    >
                        <FormattedMessage
                            id="noContentAvailable.NoNewResources"
                            defaultMessage="This is the space where your healthcare team shares articles and videos with you. There are no new resources to view at this time."
                        />
                    </div>
                </Container>
            </div>
        );
    }
}
